"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeputyClient = void 0;
const tslib_1 = require("tslib");
var DeputyClient_1 = require("./DeputyClient");
Object.defineProperty(exports, "DeputyClient", { enumerable: true, get: function () { return DeputyClient_1.DeputyClient; } });
(0, tslib_1.__exportStar)(require("./models/DeputyEmployeeDetails"), exports);
